<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="editActionQueue">

    <p-confirmDialog  key="cd4" #cd4>
        <ng-template pTemplate="footer">
            <button (click)="cd4.reject()" class="btn btn-basic" type="button">No</button>
            <button (click)="cd4.accept()" class="btn btn-success" type="button">Yes</button>
            <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 8px" aria-hidden="true" (click)="addNotes2ChangeLog()"></div>
        </ng-template>
    </p-confirmDialog>

    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Edit Action Queue</h5>
        <button
            (click)="bsModalRef.hide()"
            class="ms-auto fas fa-times"pe="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
        </button>
    </div>

    <div class="modal-body" style="padding-left: 10px;">
 
        <div style="display: flex; gap: 10px; margin-bottom: 20px; align-items: center;">
            <div class="form-group" style="width: 50%;">
                <label for="actionQueueName">Action Queue</label>
                <input type="text" name="actionQueueName" id="actionQueueName" [(ngModel)]="actionQueue.name" style="height: 38px; border-color: var(--kig-border-light); width: 100%;" (ngModelChange)="checkForDuplicateName()"/>
            </div>

            <div class="form-group" style="width: 50%;">
                <label for="owner">Access Group</label>
                <ngx-select-dropdown name="owner" id="owner" [config]="userGroupConfig" [options]="associatedUserGroups" [(ngModel)]="selectedUserGroup"></ngx-select-dropdown>
            </div>
        </div>
    
        <tabset>  
            <tab heading="Associated Events" class="tabset">
                <!-- <br> -->
                <div style="display: flex; margin-top: 1px;">
                    <div style="display: block; width: 100%; border: 1px solid lightgray;">
                        <div style="padding: 10px; display: flex; justify-content: space-between; width: 100%; background-color: var(--kig-section-header-bg); height: 38px;">
                            <label style="margin-top: -4px;">Events</label>
                            <label style="font-size: 14px; color: black; margin-top: -2px;">#Selected: {{ eventsSelected.length }}</label>
                        </div>

                        <div style="display: flex; border-bottom: 1px solid lightgray; margin-top: 8px;">
                            <div (click)="toggleCheckedEvents()" style="margin-left: 12px; font-size: 24px; cursor: pointer;">▣</div>
                            <i class="fa fa-search" style="margin: 12px 4px 0px 20px; cursor: pointer;" (click)="searchEventsTextChanged()"></i>
                            <form (ngSubmit)="searchEventsTextChanged()">
                                <input [(ngModel)]="eventSearchText" placeholder="Search" style="height: 35px; width: 300px; margin-bottom: 10px; margin-top: 3px;" type="text" name="eventSearchText" autocomplete="off" />
                            </form>

                            <div style="display: flex; gap: 8px; margin-left: 25px;" class="text-center">
                                <div style="display: block;">
                                    <div style="font-size: 12px;">Displayed</div>
                                    <div style="font-size: 12px;">{{ eventsDisplayed.length }}</div>
                                </div>
                                <div style="display: block;">
                                    <div style="font-size: 12px;">Selected</div>
                                    <div (click)="showSelectedEvents()" style="font-size: 12px; cursor: pointer;">{{ eventsSelected.length }}</div>
                                </div>
                                <div style="display: block;">
                                    <div style="font-size: 12px;">Total</div>
                                    <div style="font-size: 12px;">{{ events.length }}</div>
                                </div>
                            </div>
                        </div>

                        <p-table #EventsActionsTable [columns]="EventsCols" [value]="eventsDisplayed" [scrollable]="true" scrollHeight="18em" >
                            <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="i" class="data-acquisition">
                                <tr style="height: 30px;">
                                    <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                                        <p-checkbox id="{{i}}" name="{{i}}" [(ngModel)]="rowData.checked" binary="true" (ngModelChange)="eventsSelectionChanged(rowData)" ></p-checkbox>
                                    </td>

                                    <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                                        {{ rowData.name }}
                                    </td>

                                    <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                                        {{ rowData.description }}
                                    </td>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </tab>

            <tab heading="Rules" class="tabset" style="height: 443px; padding-top: 1px;">
                <table style="width: 100%; margin-bottom: 15px; border: 0px solid lightgray;">
                    <tr style="background-color: var(--kig-section-header-bg); height: 30px;">
                        <th style="width: 150px; text-align: left; padding-left: 10px;">Rule</th>
                        <th style="text-align: left; padding-left: 0px;">Description</th>
                    </tr>
                    <tr>
                        <td>
                            <div style="display: flex; gap: 10px; margin-left: 10px; margin-bottom: 15px; margin-top: 15px; align-items: center;">
                                <input [(ngModel)]="actionQueue.rulesObj.batchSize" style="height: 30px; width: 40px; text-align: center;" type="text" name="batchsize" autocomplete="off" />
                                <label style="width: 75px;">Batch Size</label>  
                                <select class="compact-dropdown" [(ngModel)]="actionQueue.rulesObj.batchReleaseCondition">
                                    <option *ngFor="let option of batchReleaseConditionOptions" [value]="option.value">
                                        {{ option.name }}
                                    </option>
                                </select>  
                            </div> 
                        </td>
                        <td style="border-bottom: 1px solid lightgray;">
                            <label style="font-size: 14px; width: 100%;">When event actions are triggered, wait for queue batch size and condition to be met</label>
                        </td>
                    </tr>


                    <tr>
                        <td>
                            <div style="display: flex; gap: 10px; margin-left: 10px; margin-bottom: 15px; align-items: center;">
                                <input [(ngModel)]="actionQueue.rulesObj.maxSimultaneousBatches" style="height: 30px; width: 40px; text-align: center;" type="text" name="maxSimultaneousBatches" autocomplete="off" />
                                <label style="width: 200px;">Max Simultaneous Batches</label>      
                            </div> 
                        </td>
                        <td style="border-bottom: 1px solid lightgray;">
                            <label style="font-size: 14px; width: 100%;">Number of batches that can be processed at the same time</label>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div style="display: flex; gap: 10px; margin-left: 10px; margin-bottom: 0px; align-items: center;"> 
                                <input [(ngModel)]="actionQueue.rulesObj.maxWaitMinutesInQueueDay" style="height: 30px; width: 40px; text-align: center; " type="text" name="maxWaitMinutesInQueueDay" autocomplete="off" />
                                <label style="width: 170px;">Wait Timeout (Day)</label>      
                            </div> 
                            <div style="margin-bottom: 15px; margin-left: 60px;">
                                <label>Starts at Hour</label>
                                <input [(ngModel)]="actionQueue.rulesObj.maxWaitInQueueDayStartHour" style="height: 30px; width: 40px; text-align: center; margin-left: 10px; border: 1px solid darkgray;" type="text" name="maxWaitInQueueDayStartHour" autocomplete="off" />
                            </div>
                        </td>
                        <td style="border-bottom: 1px solid lightgray;">
                            <label style="font-size: 14px; width: 100%;">Maximum time in minutes to wait for batch size to be filled before releasing queued actions.</label> 
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div style="display: flex; gap: 10px; margin-left: 10px; margin-bottom: 0px; align-items: center;"> 
                                <input [(ngModel)]="actionQueue.rulesObj.maxWaitMinutesInQueueNight" style="height: 30px; width: 40px; text-align: center;" type="text" name="maxWaitMinutesInQueueNight" autocomplete="off" />
                                <label style="width: 170px;">Wait Timeout (Night)</label>      
                            </div> 
                            <div style="margin-bottom: 15px; margin-left: 60px;">
                                <label>Starts at Hour</label>
                                <input [(ngModel)]="actionQueue.rulesObj.maxWaitInQueueNightStartHour" style="height: 30px; width: 40px; text-align: center; margin-left: 10px; border: 1px solid darkgray;" type="text" name="maxWaitInQueueNightStartHour" autocomplete="off" />
                            </div>
                        </td>
                        <td style="border-bottom: 1px solid lightgray;">
                            <label style="font-size: 14px; width: 100%;">Maximum time in minutes to wait for batch size to be filled before releasing queued actions.</label>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div style="display: flex; gap: 10px; margin-left: 10px; margin-bottom: 15px; align-items: center;"> 
                                <input [(ngModel)]="actionQueue.rulesObj.batchRunTimeoutMinutes" style="height: 30px; width: 40px; text-align: center;" type="text" name="batchRunTimeoutMinutes" autocomplete="off" />
                                <label style="width: 200px;">Run Timeout (min)</label>      
                            </div> 
                        </td>
                        <td style="border-bottom: 1px solid lightgray;">
                            <label style="font-size: 14px; width: 100%;">Maximum time in minutes to wait for current batch to finish.</label>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div style="display: flex; gap: 10px; margin-left: 10px; margin-bottom: 15px; align-items: center;"> 
                                <p-toggleswitch id="queueManualTriggers" [(ngModel)]="actionQueue.rulesObj.queueManualTriggers" [ngModelOptions]="{standalone: true}" required></p-toggleswitch>
                                <label style="width: 150px;">Queue Manual Triggers</label>      
                            </div> 
                        </td>
                        <td style="border-bottom: 1px solid lightgray;">
                            <label style="font-size: 14px; width: 100%;">When an Event-Action is manually triggered, it will be added to the queue.</label>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div style="display: flex; gap: 10px; margin-left: 10px; margin-bottom: 15px; align-items: center;"> 
                                <p-toggleswitch id="allowDuplicateEventsInQueue" [(ngModel)]="actionQueue.rulesObj.allowDuplicateEventsInQueue" [ngModelOptions]="{standalone: true}" required></p-toggleswitch>
                                <label style="width: 180px;">Allow Duplicate Events</label>      
                            </div> 
                        </td>
                        <td style="border-bottom: 1px solid lightgray;">
                            <label style="font-size: 14px; width: 100%;">Allow duplicate actions for an event to be added to the queue.</label>
                        </td>
                    </tr>
                </table>
            </tab>

            <tab heading="Settings" class="tabset">
                <div style="margin: 20px; display: flex; gap: 10px; align-items: center;">
                    <label for="saveQueueHistoryDays">Save Queue History (Days):</label>
                    <input style="width: 100px;" type="number" class="form-control" id="saveQueueHistoryDays" [(ngModel)]="actionQueue.saveQueueHistoryDays" min="1" max="30">
                </div>
            </tab>

        </tabset>

        <div style="display: block">
            <button style="height: 35px; padding-top: 4px; margin-bottom: 15px; margin-top: 15px;" (click)="createOrUpdateActionQueue()" class="btn btn-success pull-right" type="button">{{ actionQueue.id == 0 ? 'Create' : 'Update' }}</button>
            <button style="height: 35px; padding-top: 4px; margin-right: 20px; margin-bottom: 15px; margin-top: 15px;" (click)="bsModalRef.hide()" class="btn pull-right" type="button">Cancel</button>
        </div>

    </div>
</div>


